import { INSPECTION_ITEM_RESPONSE } from '@/_legacy/constants';
import Card from '@/_legacy/components/Card.vue';
import Checkbox from '@/_legacy/views/Analytics/Checklist/Questions/Checkbox.vue';
import List from '@/_legacy/views/Analytics/Checklist/Questions/List.vue';
import Responses from '@/_legacy/views/Analytics/Checklist/Questions/Responses';
import Photo from '@/_legacy/views/Analytics/Checklist/Questions/Photo.vue';
import Instruction from '@/_legacy/views/Analytics/Checklist/Questions/Instruction';
import { computed, h, defineComponent } from 'vue';

function shouldDisplay(item) {
  return !item.params || (item.params && !item.params.automatic);
}

export default defineComponent({
  name: 'Question',
  props: ['item', 'questions', 'responseSets', 'hasMultiplePages', 'questionsToFetch'],
  setup(props) {
    return function render() {
      const questions = props.questions[props.item.uuid];

      function questionType(type) {
        switch (type) {
          case INSPECTION_ITEM_RESPONSE.LIST:
            return List;
          case INSPECTION_ITEM_RESPONSE.CHECKBOX:
            return Checkbox;
          case INSPECTION_ITEM_RESPONSE.PHOTO:
          case INSPECTION_ITEM_RESPONSE.SIGNATURE:
          case INSPECTION_ITEM_RESPONSE.ANNOTATION:
            return Photo;
          case INSPECTION_ITEM_RESPONSE.INSTRUCTION:
            return Instruction;
          default:
            return Responses;
        }
      }

      const responseSet = props.item.params && props.item.params.response_set
        ? props.responseSets.find(set => set.uuid === props.item.params.response_set)
        : null;

      // if the question is NOT `questions` just return false (dont display loader)
      const loading = computed(() => props.questionsToFetch.includes(props.item.uuid));

      return shouldDisplay(props.item)
        ? h('div', [
          h(Card, {
            class: [
              'p-6',
              'mb-6',
            ],
            props: { loading: loading.value },
          }, [
            h('div', [
              h(questionType(props.item.response_type), {
                props: {
                  questionSet: questions || {},
                  label: props.item.title,
                  count: props.item.current,
                  uuid: props.item.uuid,
                  responseSet,
                  responseType: props.item.response_type,
                },
              }),
            ]),
          ]),
        ])
        : null;
    };
  },
});
